export default "__VITE_ASSET__a58010f2__"